function dedup(arr) {
  const unique = [...new Map(arr.map(item => [item.id, item])).values()];
  return unique;
}

export default dedup;
